/* @flow */
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import Notice from 'components/Notice.jsx';
import Table from 'components/Table.jsx';
import OrganizationActions from 'actions/OrganizationActions';
import * as React from 'react';
import { capitalize } from 'lodash';

type Props = {
  orgId: Backbone$Id,
  // TODO: require value for timeWindow when admin stats v1 is deprecated
  timeWindow?: string,
  // TODO: remove when admin stats v1 is deprecated
  messageType: string,
  actionRow?: React.Node,
};

type Teacher = {
  user_uuid: string,
  signature: string,
  group_count: number,
  announcement_count: number,
};

type State = {
  activeTeachers: Array<Teacher>,
  error: ?Error,
};

class AdminActiveTeachersTable extends React.Component<Props, State> {
  componentDidMount() {
    const { orgId, timeWindow } = this.props;

    OrganizationActions.getActiveTeachers(orgId, timeWindow)
      .then(activeTeachers => this.setState({ activeTeachers }))
      .catch(error => this.setState({ error, activeTeachers: [] }));
  }

  render() {
    const { messageType, actionRow } = this.props;

    const placeholderHeight = 100;

    if (!this.state || !this.state.activeTeachers) {
      return <LoadingIndicator height={placeholderHeight} size="small" />;
    }

    if (this.state.error) {
      return (
        <Notice color="white" height={placeholderHeight}>
          Sorry—this data is not available at this time.
        </Notice>
      );
    }

    if (this.state.activeTeachers.length === 0) {
      return (
        <Notice color="white" height={placeholderHeight}>
          Sorry—no teachers at your school have sent messages yet.
        </Notice>
      );
    }

    return (
      <Table
        head={
          <tr>
            <th>Teacher</th>
            <th>{capitalize(messageType)} sent</th>
            <th>Classes</th>
          </tr>
        }
        className="AdminActiveTeachersTable">
        <tbody>
          {this.state.activeTeachers.map(teacher => {
            return (
              <tr key={teacher.user_uuid}>
                <td>{teacher.signature}</td>
                <td>{teacher.announcement_count}</td>
                <td>{teacher.group_count}</td>
              </tr>
            );
          })}
          {actionRow && (
            <tr>
              <td colSpan={3}>{actionRow}</td>
            </tr>
          )}
        </tbody>
      </Table>
    );
  }
}
export default AdminActiveTeachersTable;
